module.exports = __webpack_public_path__ + "img/ac6.c0ecfbc9.png";